/**
 * AI配置表单组件
 * 职责: AI配置的创建和编辑表单
 * 限制: <150行
 */

import React from 'react';
import { Form, Input, Select } from 'antd';
import {
  MAIN_GOAL_LABELS,
  BUDGET_RANGE_LABELS,
  EXPERIENCE_LEVEL_LABELS,
  TIME_EXPECTATION_LABELS,
} from '../../../types/ai-analysis-types';

const { TextArea } = Input;

export const AIConfigForm: React.FC = () => {
  return (
    <>
      <Form.Item
        name="config_name"
        label="配置名称"
        rules={[{ required: true, message: '请输入配置名称' }]}
      >
        <Input placeholder="如：新手入门配置" />
      </Form.Item>

      <Form.Item
        name="main_goal"
        label="主要目标"
        rules={[{ required: true, message: '请选择主要目标' }]}
      >
        <Select placeholder="选择主要目标">
          {Object.entries(MAIN_GOAL_LABELS).map(([value, label]) => (
            <Select.Option key={value} value={value}>{label}</Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="budget_range"
        label="预算范围"
        rules={[{ required: true, message: '请选择预算范围' }]}
      >
        <Select placeholder="选择预算范围">
          {Object.entries(BUDGET_RANGE_LABELS).map(([value, label]) => (
            <Select.Option key={value} value={value}>{label}</Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="experience_level"
        label="经验水平"
        rules={[{ required: true, message: '请选择经验水平' }]}
      >
        <Select placeholder="选择经验水平">
          {Object.entries(EXPERIENCE_LEVEL_LABELS).map(([value, label]) => (
            <Select.Option key={value} value={value}>{label}</Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="time_expectation"
        label="时间预期"
        rules={[{ required: true, message: '请选择时间预期' }]}
      >
        <Select placeholder="选择时间预期">
          {Object.entries(TIME_EXPECTATION_LABELS).map(([value, label]) => (
            <Select.Option key={value} value={value}>{label}</Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="custom_requirements"
        label="补充需求"
      >
        <TextArea
          rows={4}
          placeholder="输入任何额外的要求或偏好"
        />
      </Form.Item>
    </>
  );
};

